import { Autocomplete, TextField, InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../locales/translations';
import SearchIcon from '@mui/icons-material/Search';
import { AwarenessCampaignData } from '../../../models/AwarenessCampaign';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { FiltersActions, selectSearchTerm, selectSelectedCampaignId } from '../../../store/reducers/awareness_campaigns/filters';
import { selectFilteredAwarenessCampaigns } from '../../../store/reducers/awareness_campaigns/list';

const SearchBar = () => {
    const { t } = useTranslation([Namespace.ADDRESSES]);
    const dispatch = useAppDispatch();

    const filteredMissions = useAppSelector(selectFilteredAwarenessCampaigns);

    const searchTerm = useAppSelector(selectSearchTerm);
    const selectedCampaignId = useAppSelector(selectSelectedCampaignId);

    const selectedMission = selectedCampaignId 
        ? filteredMissions.find(m => m.ID === selectedCampaignId) || null
        : null;

    const handleSetInputValue = (value: string) => {
        dispatch(FiltersActions.setSearchTerm(value));
    };

    const handleSetSelectedMission = (mission: AwarenessCampaignData | null) => {
        dispatch(FiltersActions.setSelectedCampaign(mission ? mission.ID : null));
    }

    return (
        <Autocomplete
            id="mission-search"
            options={filteredMissions}
            getOptionLabel={(option) => option.name}
            value={selectedMission}
            onChange={(event, newValue: AwarenessCampaignData | null) => {
                handleSetSelectedMission(newValue);
            }}
            inputValue={searchTerm}
            onInputChange={(event, newInputValue) => {
                handleSetInputValue(newInputValue);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={t('search_missions', { ns: Namespace.ADDRESSES }) || "Search missions"}
                    variant="outlined"
                    fullWidth
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        )
                    }}
                    sx={{
                        mb: 2,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                        }
                    }}
                />
            )}
        />
    );
};

export default SearchBar; 